module.exports = __webpack_public_path__ + "img/title+@3x.37d9f019.png";